import { RootState } from "../../../index";

export const aiServiceSettings = (state: RootState) => state?.aiServiceSettings?.data?.aiServiceSettings;
export const aiModels = (state: RootState) => state?.aiServiceSettings?.data?.aiModels;
export const apiKeyData = (state: RootState) => state?.aiServiceSettings?.data?.apiKeyData;
export const openRouterSettings = (state: RootState) => state?.aiServiceSettings?.data?.openRouterSettings;
export const aiServiceSettingsError = (state: RootState) => state?.aiServiceSettings?.error;
export const aiServiceSettingsLoading = (state: RootState) => state?.aiServiceSettings?.loading;